import { createContext, type ReactNode, useContext, useMemo } from 'react';
import { MA_CHUNG_TU, QUERY_KEYS } from '@/constants';
import { useHoaDonMuaDichVuExport } from '../hooks';
import { useCRUD } from '@/hooks';

interface HoaDonMuaDichVuSearchContextValue {
  exportToExcel: () => Promise<void>;
  canExport: boolean;
  isExporting: boolean;
  transactionOptions: { value: string; label: string; ma_gd: string }[];
}

const HoaDonMuaDichVuSearchContext = createContext<HoaDonMuaDichVuSearchContextValue | null>(null);

export function useHoaDonMuaDichVuSearchContext() {
  const context = useContext(HoaDonMuaDichVuSearchContext);
  if (!context) {
    throw new Error('useHoaDonMuaDichVuSearchContext must be used within HoaDonMuaDichVuSearchProvider');
  }
  return context;
}

export function HoaDonMuaDichVuSearchProvider({ children }: { children: ReactNode }) {
  const { exportToExcel, canExport, isExporting } = useHoaDonMuaDichVuExport();
  const { data } = useCRUD({
    endpoint: `${QUERY_KEYS.MA_GIAO_DICH}?ma_ct=${MA_CHUNG_TU.MUA_HANG.HOA_DON_MUA_DICH_VU}`
  });

  const transactionOptions = useMemo(
    () =>
      data.map(item => ({
        value: item.uuid,
        label: item.ten_gd,
        ma_gd: item.ma_gd
      })),
    [data]
  );

  const value = useMemo(
    () => ({
      exportToExcel,
      canExport,
      isExporting,
      transactionOptions
    }),
    [canExport, exportToExcel, isExporting, transactionOptions]
  );

  return <HoaDonMuaDichVuSearchContext.Provider value={value}>{children}</HoaDonMuaDichVuSearchContext.Provider>;
}
